import React from "react";
import GTMcomponent6 from "../components/GTMcomponent6";
import GtmComponent5 from "../components/GtmComponent5";
import GTMcomponent1 from "../components/GTMcomponent1";
import GTMComponent2 from "../components/GTMComponent2";
import GTMComponent3 from "../components/GTMComponent3";
import GTMComponent4 from "../components/GTMComponent4";

const Toolkit = () => {
    return(
        <>
        <GTMcomponent1/>
        <GTMComponent2/>
        <GTMComponent3/>
        {/* <GTMComponent4/> */}
        <GtmComponent5/>
        <GTMcomponent6/>
        
        </>
    )
}

export default Toolkit;